export default "__VITE_PUBLIC_ASSET__74312c2f__"